module.exports = __webpack_public_path__ + "img/3a3c8c4.svg";